import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useCallback } from 'react';
import { useMembership } from '@techstyle/react-accounts';
import { useAsset } from '@techstyle/react-assets';

function toStringSet(string) {
  var normalizeCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return new Set((string || '').toString().replace(/(, | )/g, ',').split(',').map(item => item.trim()).map(item => normalizeCase ? item.toLowerCase() : item).filter(item => item));
}

var emptySet = new Set();
export function getPromoAssetFlags(asset) {
  var flags = asset.options.customVars.flags;
  return flags ? toStringSet(flags) : emptySet;
}
export function createStringSetFilter(ids) {
  var idListSet = toStringSet(ids);
  return (item, index, array) => {
    return idListSet.has(item.toString());
  };
} // split out because SavageX isn't on react-assets yet.

export function usePromoAssetFilter(_ref) {
  var product = _ref.product,
      filterFromProps = _ref.filter;

  var _useMembership = useMembership(),
      isVip = _useMembership.isVip;

  var productCategoryIdList = product.productCategoryIdList,
      featuredProductLocationIdList = product.featuredProductLocationIdList,
      masterProductId = product.masterProductId;
  var filter = useCallback(parentFilter => (asset, index, assets) => {
    var _asset$options$custom = asset.options.customVars,
        categoryId = _asset$options$custom.categoryId,
        excludeFplIds = _asset$options$custom.excludeFplIds,
        fplId = _asset$options$custom.fplid; // Excludes: Stop checks and return immediately

    if (!masterProductId) {
      return false;
    }

    if (!parentFilter(asset, index, assets)) {
      return false;
    }

    if (typeof filterFromProps === 'function' && !filterFromProps(asset, index, assets)) {
      return false;
    }

    var flags = getPromoAssetFlags(asset);

    if (flags.has('nonVip') && isVip) {
      return false;
    }

    if (flags.has('Vip') && !isVip) {
      return false;
    }

    if (excludeFplIds && featuredProductLocationIdList) {
      var hasExcludedFpl = featuredProductLocationIdList.some(createStringSetFilter(excludeFplIds));

      if (hasExcludedFpl) {
        return false;
      }
    } // Includes


    if (fplId && featuredProductLocationIdList && !featuredProductLocationIdList.some(createStringSetFilter(fplId))) {
      return false;
    }

    if (categoryId && productCategoryIdList && !productCategoryIdList.some(createStringSetFilter(categoryId))) {
      return false;
    }

    return true;
  }, [filterFromProps, isVip, featuredProductLocationIdList, productCategoryIdList, masterProductId]);
  return filter;
} // maybe not necessary since filter was split out above?

export function useProductPromoAsset(assetContainerName, _ref2) {
  var product = _ref2.product,
      filterFromProps = _ref2.filter,
      multi = _ref2.multi;
  var filter = usePromoAssetFilter({
    product,
    filter: filterFromProps
  });
  var assetContainer = useAsset(assetContainerName, {
    filter,
    multi
  });
  var data = assetContainer.data;
  var asset = data && data.assets[0] || undefined;
  var flags = asset ? getPromoAssetFlags(asset) : emptySet;
  var bundleMessage = asset ? asset.options.customVars.bundleMessage : undefined;
  return _objectSpread(_objectSpread({}, assetContainer), {}, {
    flags,
    bundleMessage
  });
}